import React from 'react';
import { useHistory } from 'react-router-dom';
import Icon from '../../../components/Icon';

const ACTIONS = [
    { label: "Update Payment Address",   desc: "Change where your payments are sent",    icon: "payments", url: "https://srechelp.carbonsolutionsgroup.com/hc/en-us/requests/new?ticket_form_id=9545525917204" },
    { label: "Link Bank Account",        desc: "Set up or update ACH direct deposit",    icon: "account",  route: "/account/payment-settings" },
    { label: "Payment Re-issue Request", desc: "Request a replacement for a lost check", icon: "payments", url: "https://srechelp.carbonsolutionsgroup.com/hc/en-us/requests/new?ticket_form_id=6883045103892" },
    { label: "Thinking of Selling?",     desc: "Transfer your SREC contract",            icon: "help",     url: "https://srechelp.carbonsolutionsgroup.com/hc/en-us/requests/new?ticket_form_id=7264187751956" },
];

export default function QuickActions() {
    const history = useHistory();

    const handleClick = (action) => {
        if (action.route) {
            history.push(action.route);
        } else if (action.url) {
            window.open(action.url, '_blank');
        }
    };

    return (
        <div className="db-two-col-card">
            <div className="db-card-header">
                <span className="db-card-title">Quick Actions</span>
            </div>
            <div className="db-card-body">
                <div className="db-actions">
                    {ACTIONS.map((action, i) => (
                        <button key={i} className="db-action-btn" onClick={() => handleClick(action)}>
                            <div className="db-action-icon">
                                <Icon type={action.icon} size={18} color="#FFFFFF" />
                            </div>
                            <div style={{ flex: 1 }}>
                                <div className="db-action-label">{action.label}</div>
                                <div className="db-action-desc">{action.desc}</div>
                            </div>
                            <Icon type="chevron" size={16} color="#8B92A5" />
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}
